<template>
    <div class="container my-5">
        <div class="row mb-3">
            <div class="col d-flex align-items-center">
                <h2 class="mb-0">Activity Log</h2>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-primary" @click="handleAddLogItem">
                    <i class="far fa-plus"></i> Add Item
                </button>
            </div>
        </div><!-- /.row -->

        <!-- The stage layout scrolls inside .main-content rather than #page-content-wrapper -->
        <c-data-list ref="dataList" class="list-cards list-activity-log" :items="activities" scrollTarget=".main-content" @load="loadNextPage">
            <template v-slot:default="slotProps">
                <activity-log-list-item :activity="slotProps.item" @edit-activity-log-item="handleEditActivityLogItem" />
            </template>
            <template v-slot:empty>
                There are no items yet.
            </template>
        </c-data-list>

        <activity-log-drawer ref="activityLogDrawer" :edit-activity="editActivity" />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import ActivityLogListItem from 'components/projects/project/ActivityLogListItem'
    import ActivityLogDrawer from 'components/projects/project/ActivityLogDrawer'
    import { LaddaButton } from 'components/form/input'

    export default {

        components: {
            ActivityLogListItem,
            ActivityLogDrawer,
            LaddaButton,
        },

        data () {
            return {
                editActivity: {},
            }
        },

        created() {
            this.initialLoad = this.getActivityLog({ id: this.project.id })
        },

        computed: {
            ...mapState('projects/activityLog', { activities: 'list' }),
            ...mapState('projects/activityLog', ['pagination']),
            ...mapState('yodizproject', {
                project: 'single'
            }),

            haveActivities() {
                return this.activities.length > 0
            },

            filters () {
                return {
                }
            },
        },

        watch: {

        },

        methods: {
            ...mapActions('projects/activityLog', ['getActivityLog', 'getActivitiesForNextPage']),

            async loadNextPage(done) {
                try {
                    await this.initialLoad
                    await this.getActivitiesForNextPage({ id: this.project.id, payload: null })

                    done()
                } catch (error) {
                    done(true)
                }
            },

            openDrawer() {
                this.$nextTick(() => {
                    this.$refs.activityLogDrawer.open()
                })
            },

            handleEditActivityLogItem(activity) {
                this.editActivity = activity
                this.openDrawer()
            },

            handleAddLogItem() {
                this.editActivity = {type: null, status: null}
                this.openDrawer()
            }
        }
    }
</script>
